import script from "./PopDialog2.vue?vue&type=script&setup=true&lang=js"
export * from "./PopDialog2.vue?vue&type=script&setup=true&lang=js"

import "./PopDialog2.vue?vue&type=style&index=0&id=4354c06c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4354c06c"]])

export default __exports__